<template>
    <el-card class="box-card noticeBox">
        <div class="topHead clear">
            <span class="fl">客服</span>
            <span class="tip">专属</span>
        </div>
        <div class="serviceBox">
            <img class="ewm" src="https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/23/1608729783827501.png" alt="">
            <p>微信扫描二维码添加客服</p>
        </div>
        <div class="feedback">
            <div class="p1">用户体验第一</div>
            <div class="p2">若您在使用中有不满的地方，或者有新需求和建议，可点击下面按钮告诉我们</div>
            <el-button type="primary" icon="el-icon-edit-outline" class="feedbackBtn" @click="dialogState = true">反馈问题</el-button>
        </div>
        <dialigFeedback v-if="dialogState" @handleBtn="handleBtn" @handleClose="dialogState = false"></dialigFeedback>
    </el-card>
</template>

<script>
import dialigFeedback from './dialigFeedback'
import feedback from '@/services/operate/feedback'
export default {
    components: { dialigFeedback },
    data() {
        return {
            dialogState: false
        }
    },
    methods: {
        handleBtn(data) {
            feedback.addFeedback(data).then(res => {
                if (Object.is(res.code, 0)) {
                    this.$message.success('创建成功')
                    this.dialogState = false
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.noticeBox{
    width: 288px;
    margin-left: 16px;
    // padding: 24px;
    box-sizing: border-box;
    .topHead{
        font-size: 16px;
        line-height: 22px;
    }
    .tip{
        height: 22px;
        width: 42px;
        background: linear-gradient(132deg, #FF54D1 0%, #FF5468 100%);
        text-align: center;
        font-size: 12px;
        float: left;
        margin-left: 16px;
        border-radius: 5px;
        color: #fff
    }
    .serviceBox{
        padding: 32px 0 24px;
        margin-bottom: 25px;
        border-bottom: 1px solid #fff;
        font-size: 14px;
        text-align: center;
        border-image: linear-gradient(90deg, rgba(40, 40, 58, 0), rgba(54, 54, 81, 1), rgba(54, 54, 81, 1), rgba(40, 40, 58, 0)) 1 1;
    }
    .ewm{
        width: 179px;
        height: 179px;
        margin: 0 auto 9px;
        display: block
    }
    .feedback{
        .p1{
            font-size: 16px;
            line-height: 22px;
            font-weight: bold;
            text-align: center;
        }
        .p2{
            font-size: 14px;
            line-height: 22px;
            margin: 12px 0 16px;
            text-align: center;
        }
        .feedbackBtn{
            display: block;
            margin: 0 auto;
        }
    }
}
</style>
